import { getTimeFromSeconds } from 'utils/time';

const TimeCell = (params) => {
  return <div>{getTimeFromSeconds(params.value)}</div>;
};

export default TimeCell;
